/**
 * @fileoverview System-web binding for the shared fire-hazard overlay hook factory.
 * @module system-web/hooks/useFireHazardOverlay
 *
 * Responsibilities:
 * - Inject the configured system-web overlay service into the reusable hook facade.
 * Dependencies:
 * - System-web service adapter and @firesquirrel/fire-hazard-map-layers.
 * Architecture:
 * - Module-scoped dependency closure; no mutable global provider or cross-host state.
 * Notes:
 * - Map scheduling and source updates remain component-owned imperative concerns.
 */

import { createUseFireHazardOverlay } from '@firesquirrel/fire-hazard-map-layers';
import { fetchFireHazardOverlay } from '../services/fireHazardOverlayService';

/**
 * @hook useFireHazardOverlay
 * Purpose: Expose the configured system-web hazard-overlay fetch to map components.
 * Returns: fetchOverlay for viewport-scoped GeoJSON reads.
 * Side Effects: Each fetchOverlay invocation performs one service read with telemetry.
 * Offline Behavior: Failures propagate so the caller can retain existing map data.
 */
export const useFireHazardOverlay = createUseFireHazardOverlay({ fetchFireHazardOverlay });
